import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit';
import defectReducer from "./slices/defectSlice";
import inspectionReducer from "./slices/inspectionSlice";
import positiveItemReducer from "./slices/positiveItemSlice";
import userReducer from "./slices/userSlice";
import aiSummaryReducer from "./slices/aiSummarySlice";
import answerReducer from "./slices/answerSlice";
import checklistReducer from "./slices/checklistSlice";
import attachmentReducer from "./slices/attachmentSlice";

export const store = configureStore({
    reducer: {
        defect: defectReducer,
        inspection: inspectionReducer,
        positiveItem: positiveItemReducer,
        user: userReducer,
        aiSummary: aiSummaryReducer,
        answer: answerReducer,
        checklist: checklistReducer,
        attachment: attachmentReducer,
    },
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
    ReturnType,
    RootState,
    unknown,
    Action<string>
>;
